module.exports = __webpack_public_path__ + "static/media/status_check.09cda935.svg";